import { useMutation } from '@apollo/client';
import {
  UpdateChargeVerificationConfigMutation,
  UpdateChargeVerificationConfigMutationVariables,
} from 'graphql-query-contracts';
import { updateChargeVerificationConfigMutation } from 'graphql-queries';

import { ChargeVerificationSaveError } from './chargeVerificationSaveError';

type UpdateChargeVerificationConfigInput = {
  channelId: string;
  chargeVerificationEnabled: boolean;
};

export function useUpdateChargeVerificationConfig() {
  const [mutate] = useMutation<
    UpdateChargeVerificationConfigMutation,
    UpdateChargeVerificationConfigMutationVariables
  >(updateChargeVerificationConfigMutation);

  const updateChargeVerificationConfig = async (
    input: UpdateChargeVerificationConfigInput
  ): Promise<void> => {
    try {
      await mutate({ variables: { input } });
    } catch (cause) {
      const saveError = new ChargeVerificationSaveError(cause);

      throw saveError;
    }
  };

  return { updateChargeVerificationConfig };
}
